import React from "react"
import { useSelector } from "react-redux";
import { Controller, useFormContext, useController } from "react-hook-form";
import classNames from "classnames";
import RenderedHtmlContent from "../../../../../../shared/virtual_congress/components/rendered_html_content";
import CustomError from "../custom_error";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import green from "@material-ui/core/colors/green";
import ConditionalDivWrapper from "./conditional_div_wrapper";
import { convertFieldNameToClassName } from "../../../utils";
import CustomBoostrapRadioButtonCheckbox from "./custom_inputs/custom_radio_button_checkbox.jsx";

const BootstrapRadioButtonCheckbox = ({
  name,
  type,
  label,
  options,
  variant,
  readOnly,
  hint,
  errorMessage,
  defaultValue,
  onChange
}) => {
  const { register } = useFormContext();

  const labelWidth = useSelector(state => state.label_width) || "3"
  const inputWidth = useSelector(state => state.input_width) || "8"
  const isHorizontal = variant !== "vertical"
  const isNiceStyle = useSelector(state => state.radio_button_checkbox_style) === "nice_style"

  return <div
    className={classNames(`form-group radio-button-checkbox-container radio-button-checkbox-${convertFieldNameToClassName(name)}-container`, { "row": isHorizontal })}>
    <label htmlFor={name}
      className={classNames(`r-label`, { [`col-md-${labelWidth} col-form-label-sm`]: isHorizontal })}>
      <RenderedHtmlContent html={label} />
    </label>
    <ConditionalDivWrapper wrapWithDiv={isHorizontal} className={`col-md-${inputWidth}`}>
      {options.map(option => {
        if (isNiceStyle) {
          return <CustomBoostrapRadioButtonCheckbox
            name={name}
            option={option}
            type={type}
            readOnly={readOnly}
            onChange={onChange}
            errorMessage={errorMessage}
          />
        } else {
          return <div key={`${name}_option_${option.value}`}
            className={classNames("form-check", { "is-invalid": errorMessage })}>
            <input
              {...register(name, {
                onChange: onChange
              })}
              id={`${name}_option_${option.value}`}
              type={type}
              value={option.value}
              defaultChecked={defaultValue === option.value}
              disabled={readOnly || option.disabled}
              className={classNames("form-check-input", { "is-invalid": errorMessage })}
            />
            <label htmlFor={`${name}_option_${option.value}`} className="r-label form-check-label">
              {option.label}
            </label>
          </div>
        }
      })}
      {hint && <small className="form-text text-muted">
        <RenderedHtmlContent html={hint} />
      </small>}
      <CustomError error={errorMessage} className={"d-block"} />
    </ConditionalDivWrapper>
  </div>
}

const MaterialUiRadioButtonCheckbox = ({
  name,
  type,
  label,
  options,
  readOnly,
  hint,
  errorMessage,
  defaultValue,
  onChange
}) => {
  const { control, getValues, setValue, clearErrors, register } = useFormContext();
  const helperText = errorMessage || hint
  const { ref } = type === "checkbox" && register(name)


  return <div
    className={`form-group radio-button-checkbox-container radio-button-checkbox-${convertFieldNameToClassName(name)}-container`}>
    <FormControl
      error={!!errorMessage}
      component="fieldset">
      <FormLabel component="legend">
        <RenderedHtmlContent html={label} />
      </FormLabel>
      {type === "checkbox" ? <>
        {options.map(option => {
          return <FormControlLabel
            {...register(name, {
              onChange: onChange
            })}
            key={`checkbox_${name}.${option.value}`}
            disabled={readOnly || option.disabled}
            label={option.label}
            value={option.value}
            inputRef={ref}
            control={<Checkbox color={"primary"} />}
          />
        })}
      </> : <Controller
        name={name}
        control={control}
        defaultValue={defaultValue || ""}
        render={({ field }) => <RadioGroup {...field}>
          {options.map(option => {
            return <FormControlLabel
              key={`radio_${name}.${option.value}`}
              disabled={readOnly || option.disabled}
              label={option.label}
              value={option.value}
              control={<Radio onChange={onChange} color={"primary"} />}
            />
          })}
        </RadioGroup>}
      />}

      {helperText && <FormHelperText>
        <RenderedHtmlContent html={helperText} />
      </FormHelperText>}
    </FormControl>
  </div>
}

// Props:
// type
// name
// label
// options
// readOnly
// hint
// errorMessage
// onChange
const FlaveRadioButtonCheckbox = (props) => {
  const formFieldStyle = useSelector(state => state.form_field_style)

  switch (formFieldStyle) {
    case "material_ui":
    case "material_ui_outlined":
    case "material_ui_filled":
      return <MaterialUiRadioButtonCheckbox {...props} />
    case "boostrap_vertical":
      return <BootstrapRadioButtonCheckbox {...props} variant={"vertical"} />
    case "boostrap_horizontal":
    default:
      return <BootstrapRadioButtonCheckbox {...props} variant={"horizontal"} />
  }
}

export default FlaveRadioButtonCheckbox